import { render, staticRenderFns } from "./CartOrderItem.vue?vue&type=template&id=557583f0&scoped=true&"
import script from "./CartOrderItem.vue?vue&type=script&lang=js&"
export * from "./CartOrderItem.vue?vue&type=script&lang=js&"
import style0 from "./CartOrderItem.vue?vue&type=style&index=0&id=557583f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557583f0",
  null
  
)

export default component.exports